<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QWeHR5/tc-custom/9781617452581.jpg?1731214479669" alt="This image is the cover for the book Piecing Makeover"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Piecing Makeover
      </h1>
      <p class="bookDescription body article font2">
        <p>Do your quilt blocks tend to misbehave?  Perfect your patchwork with a visual, step-by-step guide to 21 popular quilt blocks. Piecing expert Patty Murphy shows you how with fail-proof techniques that can be used in all types of quilt designs, from traditional to modern. Say goodbye to patchwork problems like mismatched seams, blunt points, and too-small blocks, and learn to avoid common mistakes in sashings, borders, and bindings. Though mistakes happen to all of us, these easy techniques will help beginning and intermediate quilters achieve quiltmaking success every time.  • Learn to flawlessly construct 21 popular blocks in both traditional and modern designs • Step-by-step photos guide new and intermediate quilters  • Avoid common patchwork problems like mismatched seams with expert tips from a lifelong quilter</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patty Murphy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?96f64ea6